import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { fmtIDR } from "../lib/format";

export type WfStep = { key: string; label: string; value: number; kind: "start" | "plus" | "minus" | "end" };

const COLOR: Record<WfStep["kind"], string> = { start: "#64748B", plus: "#059669", minus: "#DC2626", end: "#2563EB" };

export function Waterfall({ steps, onPick }: { steps: WfStep[]; onPick?: (k: string) => void }) {
  let run = 0;
  const data = steps.map((s) => {
    if (s.kind === "start") { run = s.value; return { ...s, base: 0, bar: s.value }; }
    if (s.kind === "end") return { ...s, base: 0, bar: s.value };
    const from = run;
    run += s.kind === "plus" ? s.value : -s.value;
    return { ...s, base: Math.min(from, run), bar: Math.abs(s.value) };
  });
  return (
    <div className="h-72 w-full" data-testid="cashflow-waterfall">
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 40 }} onClick={(e: any) => e?.activePayload?.[0] && onPick?.(e.activePayload[0].payload.key)}>
          <XAxis dataKey="label" interval={0} angle={-28} textAnchor="end" tick={{ fontSize: 10 }} height={60} />
          <YAxis tickFormatter={(v) => `${Math.round(v / 1e6)} jt`} tick={{ fontSize: 10 }} width={48} />
          <Tooltip formatter={(v: any, n: any, p: any) => (n === "bar" ? [fmtIDR(p.payload.kind === "minus" ? -p.payload.value : p.payload.value), p.payload.label] : [null, null])} labelFormatter={() => ""} />
          <Bar dataKey="base" stackId="w" fill="transparent" isAnimationActive={false} />
          <Bar dataKey="bar" stackId="w" radius={[3, 3, 0, 0]} cursor={onPick ? "pointer" : undefined}>
            {data.map((d) => <Cell key={d.key} fill={COLOR[d.kind]} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
